import { productServiceTypes } from ".";
import { Doc } from "../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../lib/types/filters_types";

// Filtra productos/servicios por tipo (product | service)
export const productTypeRule: FilterRule<Doc<"products">> = {
  priority: 3,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"products">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;

    if (!args.type) return undefined;

    const valid = productServiceTypes.members.map((t) => t.value);
    if (!valid.includes(args.type as any)) return undefined;

    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    return ctx.db
      .query("products")
      .withIndex("by_company_and_type", (q) =>
        q
          .eq("internalControl.companyId", userContext.companyId!)
          .eq("type", args.type as any),
      )
      .collect();
  },
};

// Filtra productos por marca (brandId)
export const productBrandRule: FilterRule<Doc<"products">> = {
  priority: 5,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"products">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;

    if (!args.brandId) return undefined;

    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    return ctx.db
      .query("products")
      .withIndex("by_company_and_brand", (q) =>
        q
          .eq("internalControl.companyId", userContext.companyId!)
          .eq("brandId", args.brandId as Doc<"brands">["_id"]),
      )
      .collect();
  },
};

// Filtra productos que incluyen una categoría específica
export const productCategoryRule: FilterRule<Doc<"products">> = {
  priority: 4,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"products">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;
    // categories es array en schema; aquí se recibe un único categoryId
    const categoryId = (args as any).categoryId as Doc<"categories">["_id"] | undefined;

    if (!categoryId) return undefined;

    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    const products = await ctx.db
      .query("products")
      .withIndex("by_company_id", (q) =>
        q.eq("internalControl.companyId", userContext.companyId!),
      )
      .collect();

    return products.filter((product) =>
      product?.categories?.includes(categoryId),
    );
  },
};

// Filtra productos por estado interno (active | deleted)
export const productInternalControlStateRule: FilterRule<Doc<"products">> = {
  priority: 6,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"products">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;
    const state = args.internalControl?.state;

    if (!state) return undefined;

    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    const products = await ctx.db
      .query("products")
      .withIndex("by_company_id", (q) =>
        q.eq("internalControl.companyId", userContext.companyId!),
      )
      .collect();

    return products.filter(
      (product) => product?.internalControl?.state === state,
    );
  },
};
